let funData = [{
  type: "生产/制造",
  zid: "",
  department: [{
    name: "普工/技工其他",
      zid: "",
      manager: [{
        name: "普工",
        close: false
      }, {
        name: "学徒工",
        close: false
      }, {
        name: "包装工",
        close: false
      }, {
        name: "操作工",
        close: false
      }, {
        name: "装配工",
        close: false
      }, {
        name: "电子装配",
        close: false
      }, {
        name: "冲压工",
        close: false
      }, {
        name: "SMT操作员",
        close: false
      }, {
        name: "检验员",
        close: false
      }, {
        name: "数控操作工",
        close: false
      }, {
        name: "数控编程",
        close: false
      }, {
        name: "钻床",
        close: false
      }, {
        name: "磨床",
        close: false
      }, {
        name: "铣床",
        close: false
      }, {
        name: "加工中心",
        close: false
      }, {
        name: "注塑工",
        close: false
      }, {
        name: "铸造工",
        close: false
      }, {
        name: "仓管",
        close: false
      }, {
        name: "搬运工",
        close: false
      }, {
        name: "磨床",
        close: false
      }, {
        name: "钣金工",
        close: false
      }, {
        name: "电镀工",
        close: false
      }, {
        name: "维修工",
        close: false
      }, {
        name: "油漆工/喷塑工",
        close: false
      }, {
        name: "电工",
        close: false
      }, {
        name: "木工",
        close: false
      }, {
        name: "制冷/水暖工",
        close: false
      }, {
        name: "热处理",
        close: false
      }, {
        name: "钳工",
        close: false
      }, {
        name: "锅炉工",
        close: false
      }, {
        name: "电梯工",
        close: false
      },{
        name: "焊工",
        close: false
      }]
    },
    {
      name: "生产管理",
      zid: "",
      manager: [{
        name: "车间主任",
        close: false
      }, {
        name: "生产主管/组长",
        close: false
      }, {
        name: "厂长/副厂长",
        close: false
      }, {
        name: "设备维护",
        close: false
      }, {
        name: "质量管理",
        close: false
      }, {
        name: "化验/检验",
        close: false
      }, {
        name: "生产调度",
        close: false
      }, {
        name: "生产项目经理/主管",
        close: false
      }, {
        name: "统计文员",
        close: false
      }, {
        name: "生产跟单",
        close: false
      }, {
        name: "生产主管/组长",
        close: false
      }, {
        name: "安全管理",
        close: false
      }, {
        name: "储备干部",
        close: false
      }, {
        name: "实习生",
        close: false
      }, {
        name: "管培生",
        close: false
      }]
    },
    {
      name: "印刷",
      zid: "",
      manager: [{
        name: "印刷操作",
        close: false
      },{
        name: "装订/烫金",
        close: false
      },{
        name: "压痕工",
        close: false
      },{
        name: "裱胶工",
        close: false
      },{
        name: "复卷工",
        close: false
      },{
        name: "调墨技师",
        close: false
      },{
        name: "印刷机械机长",
        close: false
      },{
        name: "晒版员",
        close: false
      },{
        name: "装订工",
        close: false
      },{
        name: "电分操作员",
        close: false
      },{
        name: "打稿机操作员",
        close: false
      },{
        name: "切纸机操作工",
        close: false
      }]
    },
    {
      name: "服装/纺织",
      zid: "",
      manager: [{
        name: "样衣工",
        close: false
      }, {
        name: "电脑放码员",
        close: false
      }, {
        name: "纺织品设计师",
        close: false
      }, {
        name: "纸样师/车板工",
        close: false
      }, {
        name: "生产管理",
        close: false
      }, {
        name: "服装打样/制版",
        close: false
      }, {
        name: "裁剪工",
        close: false
      }, {
        name: "细纱工",
        close: false
      }, {
        name: "配色工",
        close: false
      }, {
        name: "漂染工",
        close: false
      }, {
        name: "染工",
        close: false
      }, {
        name: "纺织工",
        close: false
      }, {
        name: "印花工",
        close: false
      }]
    },
    {
      name: "司机/汽车服务",
      zid: "",
      manager: [{
        name: "叉车工",
        close: false
      }, {
        name: "铲车",
        close: false
      }, {
        name: "C照司机",
        close: false
      }, {
        name: "B照司机",
        close: false
      }, {
        name: "A照司机",
        close: false
      }, {
        name: "吊车司机",
        close: false
      }, {
        name: "挖掘机司机",
        close: false
      }, {
        name: "特种车司机",
        close: false
      }, {
        name: "摩托车修理",
        close: false
      }, {
        name: "汽车美容",
        close: false
      }, {
        name: "洗车工",
        close: false
      }, {
        name: "汽车修理",
        close: false
      }, {
        name: "汽车其他",
        close: false
      }]
    }]
}, {
  type: "电商/快递",
  zid: "",
  department: [{
      name: "快递物流",
      zid: "",
      manager: [{
        name: "快递员",
        close: false
      },{
        name: "收件员",
        close: false
      },{
        name: "发件员",
        close: false
      },{
        name: "装车/搬运工",
        close: false
      },{
        name: "订单处理员",
        close: false
      },{
        name: "跟车",
        close: false
      },{
        name: "发运",
        close: false
      },{
        name: "收货",
        close: false
      },{
        name: "单证",
        close: false
      },{
        name: "物流专员/助理",
        close: false
      }]
    },
    {
      name: "仓储",
      zid: "",
      manager: [{
        name: "仓库管理员",
        close: false
      }, {
        name: "仓管叉车员",
        close: false
      }, {
        name: "仓库经理/主管",
        close: false
      }, {
        name: "高位叉车",
        close: false
      }, {
        name: "分拣员",
        close: false
      }, {
        name: "扫描",
        close: false
      }, {
        name: "打包",
        close: false
      }, {
        name: "理货",
        close: false
      }]
    },
  ]
}, {
  type: "商超/酒店/餐饮",
  zid: "",
  department: [{
    name: "超市/零售其他",
    zid: "",
    manager: [{
      name: "防损员/内保",
      close: false
    }, {
      name: "收银员",
      close: false
    }, {
      name: "理货员/陈列员",
      close: false
    }, {
      name: "促销/导购员",
      close: false
    }, {
      name: "店员/营业员",
      close: false
    }, {
      name: "店长/卖场经理",
      close: false
    }, {
      name: "食品加工/处理",
      close: false
    }, {
      name: "搬运岗",
      close: false
    }, {
      name: "水产理货",
      close: false
    }, {
      name: "安保",
      close: false
    }]
  }, {
    name: "外卖配送",
    zid: "",
    manager: [{
      name: "外卖骑手",
      close: false
    }, {
      name: "分拣",
      close: false
    }, {
      name: "打包",
      close: false
    }, {
      name: "理货",
      close: false
    }, {
      name: "水产理货",
      close: false
    }, {
      name: "订单处理",
      close: false
    }]
  }, {
    name: "酒店/餐饮",
    zid: "",
    manager: [{
      name: "传菜员",
      close: false
    },{
      name: "面点师",
      close: false
    },{
      name: "后厨",
      close: false
    },{
      name: "厨师/厨师长",
      close: false
    },{
      name: "服务员",
      close: false
    },{
      name: "洗碗工",
      close: false
    },{
      name: "配菜/打荷",
      close: false
    },{
      name: "迎宾/接待",
      close: false
    },{
      name: "学徒",
      close: false
    },{
      name: "杂工",
      close: false
    },{
      name: "咖啡师",
      close: false
    },{
      name: "西点师",
      close: false
    },{
      name: "餐厅领班",
      close: false
    },{
      name: "客房服务员",
      close: false
    },{
      name: "客房部经理",
      close: false
    },{
      name: "前厅部员工",
      close: false
    },{
      name: "大堂副理",
      close: false
    },{
      name: "值班经理",
      close: false
    },{
      name: "前台/接待",
      close: false
    },{
      name: "酒店管理",
      close: false
    },{
      name: "保安",
      close: false
    }]
  }],
}, {
  type: "文员/客服/营销",
  zid: "",
  department: [{
      name: "行政/文员/客服",
      zid: "",
      manager: [{
        name: "后勤",
        close: false
      },{
        name: "文员",
        close: false
      },{
        name: "内勤人员",
        close: false
      },{
        name: "人事经理",
        close: false
      },{
        name: "人事主管",
        close: false
      },{
        name: "人事专员",
        close: false
      },{
        name: "招聘经理",
        close: false
      },{
        name: "招聘专员",
        close: false
      },{
        name: "招聘主管",
        close: false
      },{
        name: "业务经理",
        close: false
      },{
        name: "业务助理",
        close: false
      },{
        name: "项目专员",
        close: false
      },{
        name: "客服经理",
        close: false
      },{
        name: "电话客服",
        close: false
      },{
        name: "客服专员",
        close: false
      },{
        name: "客服主管",
        close: false
      }]
    },
    {
      name: "市场/营销",
      zid: "",
      manager: [{
        name: "市场营销",
        close: false
      }, {
        name: "客户代表",
        close: false
      }, {
        name: "电销专员",
        close: false
      }, {
        name: "客户经理",
        close: false
      }, {
        name: "客户主管",
        close: false
      }, {
        name: "网络销售",
        close: false
      }, {
        name: "销售经理/主管",
        close: false
      }, {
        name: "销售业务跟单",
        close: false
      }, {
        name: "市场专员/助理",
        close: false
      }, {
        name: "公关经理/主管",
        close: false
      }, {
        name: "业务拓展专员/助理",
        close: false
      }, {
        name: "会务会展专员",
        close: false
      }, {
        name: "会务经理/主管",
        close: false
      }, {
        name: "客户主管",
        close: false
      }, {
        name: "客户专员",
        close: false
      }]
    }
  ]
}, {
  type: "物业/家政/美发",
  zid: "",
  department: [{
      name: "美容美发",
      zid: "",
      manager: [{
        name: "美容师",
        close: false
      },{
        name: "美甲师",
        close: false
      },{
        name: "美发助理/学徒",
        close: false
      },{
        name: "美容导师",
        close: false
      },{
        name: "洗头工",
        close: false
      },{
        name: "发型师",
        close: false
      },{
        name: "化妆师",
        close: false
      },{
        name: "美容助理/学徒",
        close: false
      },{
        name: "美容/瘦身顾问",
        close: false
      }]
    },
    {
      name: "物业/家政保洁",
      zid: "",
      manager: [{
        name: "监控维护",
        close: false
      }, {
        name: "物业维修",
        close: false
      }, {
        name: "物业管理",
        close: false
      }, {
        name: "物业经理/主管",
        close: false
      }, {
        name: "物业顾问",
        close: false
      }, {
        name: "保安",
        close: false
      }, {
        name: "洗衣工",
        close: false
      }, {
        name: "护工",
        close: false
      }, {
        name: "保姆",
        close: false
      }, {
        name: "送水工",
        close: false
      }, {
        name: "育婴师/保育员",
        close: false
      }, {
        name: "月嫂",
        close: false
      }, {
        name: "保洁",
        close: false
      }, {
        name: "保安",
        close: false
      }, {
        name: "钟点工",
        close: false
      }, {
        name: "婚礼/庆典策划服务",
        close: false
      }, {
        name: "宠物护理和美容",
        close: false
      }, {
        name: "家电维修",
        close: false
      }, {
        name: "家政保洁其他",
        close: false
      }, {
        name: "垃圾分类员",
        close: false
      }]
    }
  ]
}, {
  type: "财务/教育/计算机",
  zid: "",
  department: [{
    name: "财务/会计/审计",
    zid: "",
    manager: [{
      name: "出纳",
      close: false
    }, {
      name: "统计员",
      close: false
    }, {
      name: "财务总监",
      close: false
    }, {
      name: "税务专员/助理",
      close: false
    }, {
      name: "财务/会计助理",
      close: false
    }, {
      name: "会计/会计师",
      close: false
    }, {
      name: "财务经理/主管",
      close: false
    }, {
      name: "审计经理/主管",
      close: false
    }, {
      name: "审计专员/助理",
      close: false
    }, {
      name: "税务经理/主管",
      close: false
    }, {
      name: "财务分析员",
      close: false
    }, {
      name: "财务其他",
      close: false
    }]
  },{
    name: "教育培训",
    zid: "",
    manager: [{
      name: "培训策划",
      close: false
    }, {
      name: "教育产品开发",
      close: false
    }, {
      name: "家教",
      close: false
    }, {
      name: "幼教/早教",
      close: false
    }, {
      name: "教师/助教",
      close: false
    }, {
      name: "培训助理",
      close: false
    }, {
      name: "招生/课程顾问",
      close: false
    }, {
      name: "教育培训其他",
      close: false
    }]
  },{
    name: "计算机/互联网/通信",
    zid: "",
    manager: [{
      name: "技术支持/维护",
      close: false
    }, {
      name: "网络管理员",
      close: false
    }, {
      name: "软件开发员",
      close: false
    }]
  }]
}, {
  type: "兼职/临时工",
  zid: "",
  department: [{
    name: "兼职",
    zid: "",
    manager: [{
      name: "短期兼职",
      close: false
    }, {
      name: "长期兼职",
      close: false
    }, {
      name: "周末兼职",
      close: false
    }, {
      name: "工厂兼职",
      close: false
    }, {
      name: "餐饮业兼职",
      close: false
    }, {
      name: "超市店员兼职",
      close: false
    }, {
      name: "家政兼职",
      close: false
    }, {
      name: "家教兼职",
      close: false
    }]
  }, {
    name: "临时工",
    zid: "",
    manager: [{
      name: "短期临时工",
      close: false
    }, {
      name: "临时工",
      close: false
    }, {
      name: "普工临时工",
      close: false
    }, {
      name: "日结临时工",
      close: false
    }, {
      name: "周结临时工",
      close: false
    }, {
      name: "月结临时工",
      close: false
    }]
  }]
}];

export default funData;